import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-pagination', 'title', 'Постраничная навигация');
Labels.set('ui-pagination', 'previousPage', 'Предыдущая страница');
Labels.set('ui-pagination', 'nextPage', 'Следущая страница');
Labels.set('ui-pagination', 'currentPage', 'Текущая страница');
Labels.set('ui-pagination', 'page', 'Страница');
Labels.set('ui-pagination', 'show', 'Показывать на странице');
